import isEmpty from 'lodash/isEmpty';
import React from 'react';
import {
    isTierVariantNotBestAvailable,
    isTierVariantNotSoldOut,
} from '../../containers/ticketSelection/utils/ticketUtils';
import { TicketVariant } from '../../models/tickets';
import { MEDIUM_COLOR_CIRCLE_SIZE } from '../tierColorCircle/constants';
import { TierColorCircle } from '../tierColorCircle/TierColorCircle';
import './TierPile.scss';

/**
 * TierPile
 *
 * Returns first three tiers based on order returned by the api
 *
 * @param {Array} variants Array of ticket objects output by formatTicketsForDisplay
 * (see ticketUtils.js)
 * @returns {Array} An array <TierColorCircle /> components
 */
const TierPile = ({
    variants,
    iconSize = MEDIUM_COLOR_CIRCLE_SIZE,
}: {
    variants: Array<TicketVariant>;
    iconSize?: string;
}) => {
    if (isEmpty(variants)) {
        throw new Error(`Invalid argument: ${variants}`);
    }

    const tierVariants = variants.filter((variant) =>
        isTierVariantNotBestAvailable(variant),
    );
    const tierVariantsNotSoldOut = tierVariants.filter((variant) =>
        isTierVariantNotSoldOut(variant),
    );
    let variantsForPileDisplay;

    if (isEmpty(tierVariantsNotSoldOut)) {
        variantsForPileDisplay = tierVariants;
    } else {
        variantsForPileDisplay = tierVariantsNotSoldOut;
    }

    const pile = variantsForPileDisplay
        .slice(0, 3)
        .map((variant) => (
            <TierColorCircle
                tierColor={variant.color ?? ''}
                colorCircleSize={iconSize}
                key={variant.id}
            />
        ));

    return <div className="tier-pile eds-l-mar-right-2">{pile}</div>;
};

export default TierPile;
